// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1olLC","balanceDisclaimer":"posDashboard_balanceDisclaimer__24jfA"};